(function(){
  var KEY='nv_wishlist_v1';
  function count(){try{var a=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a.length:0;}catch(e){return 0;}}
  function paint(){
    var n=count();
    document.querySelectorAll('[data-nv-wl-count]').forEach(function(el){
      el.textContent=n>99?'99+':n;
      el.style.display=n>0?'':'none';
    });
  }
  paint();
  document.addEventListener('DOMContentLoaded',paint);
  document.addEventListener('nv:wishlist',paint);
  window.addEventListener('storage',function(e){if(!e.key||e.key===KEY)paint();});
  window.addEventListener('pageshow',paint);
})();
